var e = function (t) {
  return t.topLeft = "top-left", t.topMiddle = "top-middle", t.topRight = "top-right", t.bottomLeft = "bottom-left", t.bottomMiddle = "bottom-middle", t.bottomRight = "bottom-right", t.left = "left", t.right = "right", t;
}(e || {});

export { e as Positions };